<div class="container container-fixed">
  <div class="row">
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label>Partner Key</label>
        <input id="searchDetailsEdiPortalId" class="form-control" readonly [ngModel]="$safeNavigationMigration(clonedPartner?.EdiPortalId)" />
      </div>

      <div class="form-group">
        <label>Partner Name</label>
        <input id="searchDetailsPartnerName"  class="form-control" [readonly]="!isEditing" [ngModel]="$safeNavigationMigration(clonedPartner?.PartnerName)" (ngModelChange)="clonedPartner.PartnerName = $event" />
      </div>

      <div class="form-group">
        <label>Partner Type</label>
        <select id="partnerType" class="form-control" [disabled]="!isEditing" [ngModel]="$safeNavigationMigration(clonedPartner?.PartnerType)" (ngModelChange)="clonedPartner.PartnerType = $event">
          @for (partnerType of partnerTypes; track partnerType) {
            <option [ngValue]="partnerType">{{partnerType.Name}}</option>
          }
        </select>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label>Comment</label>
        <textarea [disabled]="!isEditing" class="form-control" rows="9" [ngModel]="$safeNavigationMigration(clonedPartner?.Comment)" (ngModelChange)="clonedPartner.Comment = $event"></textarea>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <!-- ToDo: button does not hide when editing. -->
      @if (!isEditing) {
        <div>
          <button class="btn btn-primary" type="button" (click)="edit()" *bizPermissionRequired="['Partner_Action_GeneralEdit', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Edit</button>
        </div>
      }
      @if (isEditing) {
        <button class="btn btn-primary" type="button" (click)="save()">Save</button>
      }
      @if (isEditing) {
        <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</div>
